import { principles } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Principles() {
  return (
    <section id="principles" className="scroll-mt-20 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="吃瓜守则"
          title="热闹看得清，更要看得稳"
          desc="吃瓜无门槛，但理性有底线。我们倡导健康、文明的吃瓜氛围，也把它写进了我们的内容准则。"
          accentIcon="ri-shield-check-line"
          align="center"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div
              key={p.title}
              className="group rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:shadow-card"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-accent-500 to-accent-600 text-xl text-background-50 transition-transform group-hover:scale-110">
                <i className={p.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}